import type { DrawerContentProps } from '@base-ui/react';

import { Drawer as BaseDrawer } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { contentStyle } from './Drawer.css';

type Props = DrawerContentProps;

export const DrawerContent = ({ children, ...delegated }: Props) => {
  return (
    <BaseDrawer.Content {...delegated} className={clsxs(contentStyle, delegated.className)}>
      {children}
    </BaseDrawer.Content>
  );
};
